import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useRef } from 'react';

import { ProfileUploadSection } from 'enrollment/components/ProfilePicture/ProfileUploadSection';
import { InternalPage, Loader } from 'theSource/components';
import { AvatarFamilyDrawerBoxStyled } from './FamilyDetailsPageStyled';
import { useApiMutation } from 'theSource/utils';
import { ErrorResponseDto, FormValuesDto, ResponseDto } from 'theSource/types';
import { EDIT_DEPENDENT_QUERY_KEY } from 'enrollment/queries/useEnrollmentFamilyQuery';
import { useConfigurationQuery } from 'theSource/queries';
import { OrbitDrawer } from 'enrollment/components/Shared/OrbitDrawer';
import { chooseFamilyAvatarAction } from 'enrollment/features/ProfileEdit/Avatar/AvatarActions';

export const AvatarFamilyDrawerDisplayPicture = ({
  enrollmentContextType,
  openFamilyAvatarDrawer,
  handleCloseAvatarDrawer,
  orientationDivider,
  handleUploadDrawerAvatar,
  dependentId,
  isNewDependent,
}: any) => {
  const { t } = useTranslation('pages.enrollmentFamily');
  const dispatch = useDispatch();

  const avatarFamilyDrawerScrollRef = useRef(null);

  const dependentDetails = useSelector((state: any) => state.enrollment);

  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;
  const avatarObject = dependentDetails?.chooseAvatar;
  const avatarName = avatarObject?.family_avatar?.name ?? '';

  const avatarSkinTone = avatarObject?.avatarFamilySkinTone?.name ?? '';
  const avatarHairColor = avatarObject?.avatarFamilyHairColor?.name ?? '';
  const avatarShirtColor = avatarObject?.avatarFamilyShirtColor?.name ?? '';

  const subscriberProfileAvatarValue: string[] = [];
  avatarName && subscriberProfileAvatarValue.push(avatarName);
  avatarSkinTone && subscriberProfileAvatarValue.push(avatarSkinTone);
  avatarHairColor && subscriberProfileAvatarValue.push(avatarHairColor);
  avatarShirtColor && subscriberProfileAvatarValue.push(avatarShirtColor);
  const FamilyDisplayPictureIDCondition = '/enrollment/family';

  const { isLoading, mutate: saveDependentPicture } = useApiMutation<
    ResponseDto,
    ErrorResponseDto,
    FormValuesDto
  >({
    queryKey: EDIT_DEPENDENT_QUERY_KEY,
    method: 'put',
    endpoint: `${lumosApiHost}/v2/self_service/dependents/profile/${dependentId}/${enrollmentContextType}`,
    onSuccess: () => {
      handleUploadDrawerAvatar();
    },
    getErrorMessage: (error) => error.response?.data?.details,
  });

  const handleSavePicture = () => {
    dispatch(
      chooseFamilyAvatarAction({}, FamilyDisplayPictureIDCondition)
    );
    if (isNewDependent) {
      handleUploadDrawerAvatar();
      return;
    }

    saveDependentPicture({
      dependent_profile: {
        avatar: subscriberProfileAvatarValue.join('_'),
      },
    });
  };

  return (
    <OrbitDrawer
      drawerId="family-avatar-drawer"
      heading={t('addAvatarDrawerTitle')}
      isOpen={openFamilyAvatarDrawer}
      handleClose={handleCloseAvatarDrawer}
      handleSubmit={handleSavePicture}
      closeIcon="back"
      footer={true}
      saveButton={t('common:save')}
    >
      <AvatarFamilyDrawerBoxStyled ref={avatarFamilyDrawerScrollRef}>
        <InternalPage testId="add-family-avatar">
          <Typography variant="body1" textAlign="left">
            {t('addDrawerFamilyAvatarDescription')}
          </Typography>
          {isLoading ? (
            <Grid container className="py-5 my-5">
              <Loader />
            </Grid>
          ) : (
            <ProfileUploadSection
              orientationDivider={orientationDivider}
              scope="family"
              avatarFamilyDrawerScrollRef={avatarFamilyDrawerScrollRef}
            />
          )}
        </InternalPage>
      </AvatarFamilyDrawerBoxStyled>
    </OrbitDrawer>
  );
};
